<template>
  <ag-modal-container
    title="Modification d'une catégorie d'opération"
    width="800px"
    @close="back"
  >
    <operationCategory-form
      v-if="value"
      v-model="value"
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :loading="loading"
        :disabled="!isValid || !value"
        color="primary"
        class="ml-5"
        @click="update"
        v-text="'Modifier'"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import OperationCategoryForm from '../components/OperationCategoryForm'

export default {
  name: 'OperationCategoryUpdateContainer',
  components: {
    AgModalContainer,
    OperationCategoryForm,
  },
  props: {
    operationCategoryId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isValid: false,
    loading: false,
    value: null,
  }),
  watch: {
    $route: {
      immediate: true,
      async handler () {
        this.value = await Repositories.operationCategory.get(this.operationCategoryId)
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async update () {
      this.loading = true
      try {
        await Repositories.operationCategory.patch(this.value)
        this.showSuccessNotification(`La modification de ${this.value.name} est validé`)
        this.back()
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
